import React, { useState, useEffect } from "react";
import { Container, TextField, Card, Button, Typography, Grid, CardActions, LinearProgress, FormControl, Switch, Select, MenuItem } from '@mui/material';
import { useNavigate, useParams } from "react-router-dom";
import CommonListHeader from "components/layout/list/header";
import { useSelector, useDispatch } from 'react-redux'
import { userCreate, resetRequestId } from 'api/user';
import { useUserEditMutation, useUserDetailsQuery, useSmListQuery } from "services/user";
import { useGetRoleByCodeQuery, useRoleListQuery } from "services/role";
import { useOrgDetailsQuery, useOrgQListQuery } from "services/org";

const UserEdit = (props) => {
    const navi = useNavigate();
    const dispatch = useDispatch();
    const { userId } = useParams();
    const requestId = useSelector(state => state.user.requestId);
    const user = useSelector(state => state.user.create);
    const [disableButton, setDisableButton] = useState(false);
    const [userEditMutation, { isLoading: isUpdating }] = useUserEditMutation();

    const handleCancel = () => {
        navi(`/users/details/${userDetails.id}`);
    }


    const { userDetails } = useUserDetailsQuery(
        {
            id: userId,
            requestId: requestId
        },
        {
            skip: !userId,
            selectFromResult: ({ data }) => ({
                userDetails: data || {}
            })
        }
    );

    useEffect(() => {
        if (userDetails.id) {
            dispatch(userCreate({
                firstName: userDetails?.firstName || '',
                lastName: userDetails?.lastName || '',
                role: userDetails?.role || '',
                smId: userDetails?.smId || '',
                orgId: userDetails?.orgId || '',
                phone_number: userDetails?.phone_number || '',
                phone: userDetails?.phone || '',
                username: userDetails?.username || '',
                status: userDetails?.status || false,
                id: userId
            }))
        }
    }, [userDetails])



    const { smDetails } = useUserDetailsQuery(
        {
            id: userDetails.smId,
            requestId: requestId
        },
        {
            skip: !userDetails.smId,
            selectFromResult: ({ data }) => ({
                smDetails: data || {}
            })
        }
    );



    const { orgDetails } = useOrgDetailsQuery({ id: user.orgId },
        {
            skip: !user.orgId,
            selectFromResult: ({ data }) => ({
                orgDetails: data || {}
            })
        }
    );

    const { roleDetails } = useGetRoleByCodeQuery({ code: userDetails.role },
        {
            skip: !userDetails.role,
            selectFromResult: ({ data, status, isLoading, isFetching }) => ({
                roleDetails: data || {}
            })
        }
    );

    const { orgList } = useOrgQListQuery({},
        {
            selectFromResult: ({ data }) => ({
                orgList: data?.hits?.hits?.map(s => s._source) || [],
            })
        }
    );

    const { roleList } = useRoleListQuery({},
        {
            selectFromResult: ({ data }) => ({
                roleList: data?.hits?.hits?.map(s => s._source) || [],
            })
        }
    );

    const { smList } = useSmListQuery({ orgId: user.orgId },
        {
            skip: !user.orgId,
            selectFromResult: ({ data }) => ({
                smList: data?.map(s => s._source) || [],
            })
        }
    );

    const onSave = () => {
        if (user.role !== 'adv') {
            dispatch(userCreate({ smId: '' }));
        }
        var record = {
            "doc": {
                ...user,
                id: userId
            }

        }
        setDisableButton(true);
        userEditMutation(record)
            .unwrap()
            .then(result => {
                console.log(result);
                //dispatch(resetRequestId());
                setDisableButton(false);

                navi(`/users/details/${userDetails.id}`);
            })
            .catch(err => {
                setDisableButton(false);
            })

    }

    return (
        <React.Fragment>
            <CommonListHeader value={{ title: `Edit User: ${user.firstName} ${user.lastName}`, description: "You are editing User details." }} />
            <Container maxWidth={'md'}>
                <Card>
                    {disableButton ? <LinearProgress /> : ''}
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                        <Grid item md={3}>
                            <Typography variant="body1">First Name</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                onChange={(event) => dispatch(userCreate({ firstName: event.target.value }))}
                                value={user.firstName || ''}
                            />
                        </Grid>
                    </Grid>
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                        <Grid item md={3}>
                            <Typography variant="body1">Last Name</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                onChange={(event) => dispatch(userCreate({ lastName: event.target.value }))}
                                value={user.lastName || ''}
                            />
                        </Grid>
                    </Grid>
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                        <Grid item md={3}>
                            <Typography variant="body1">Role</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <FormControl fullWidth>

                                <Select
                                    value={user.role}
                                    label=""
                                    onChange={(event) => dispatch(userCreate({ role: event.target.value }))}
                                >
                                    {roleList?.map((o, i) =>
                                        <MenuItem key={i} value={o.code}>{`${o.name} (code: ${o.code})`}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    {user.role !== "sa" ? <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                        <Grid item md={3}>
                            <Typography variant="body1">Organization</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <FormControl fullWidth>

                                <Select
                                    value={user.orgId}
                                    label=""
                                    onChange={(event) => dispatch(userCreate({ orgId: event.target.value }))}
                                >
                                    {orgList?.map((o, i) =>
                                        <MenuItem key={i} value={o.id}>{`${o.name}`}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid> : ''}
                    {user.role === "adv" ? <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                        <Grid item md={3}>
                            <Typography variant="body1">Service Manager</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <FormControl fullWidth>

                                <Select
                                    value={user.smId}
                                    label=""
                                    onChange={(event) => dispatch(userCreate({ smId: event.target.value }))}
                                >
                                    {smList?.map((o, i) =>
                                        <MenuItem key={i} value={o.id}>{`${o.firstName} ${o.lastName}`}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid> : ''}



                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                        <Grid item md={3}>
                            <Typography variant="body1">E-Mail / UserName</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <Typography variant="body1">{userDetails.username || ''}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                        <Grid item md={3}>
                            <Typography variant="body1">Phone</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <Typography variant="body1">{userDetails.phone_number || ''}</Typography>
                        </Grid>
                    </Grid>

                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                        <Grid item md={3}>
                            <Typography variant="body1">Status</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <Switch checked={userDetails?.status || false} onChange={(event) => dispatch(userCreate({ status: event.target.checked }))} />
                        </Grid>
                    </Grid>


                    <CardActions sx={{ padding: "15px" }}>
                        <Button
                            disabled={disableButton}
                            variant="contained"
                            color='primary'
                            type="submit"
                            onClick={() => onSave()}
                        >
                            Submit
                        </Button>
                        <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => handleCancel()}
                        >
                            Cancel
                        </Button>
                    </CardActions>
                </Card>
            </Container>
        </React.Fragment>
    )


}

export default UserEdit;